export default __webpack_public_path__ + "static/media/kuvantaminen.afe8e1d9.svg";